export { default } from './EncounterDetailsPopup';
